export const resolvePointsHistoryPageInput = (
  value: string,
  totalPages: number,
  currentPage: number,
): number => {
  const maxPage = Math.max(1, Math.trunc(totalPages));
  const parsed = Number.parseInt(value.trim(), 10);
  if (!Number.isFinite(parsed)) {
    return Math.min(Math.max(1, currentPage), maxPage);
  }
  return Math.min(Math.max(1, parsed), maxPage);
};
